import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Network, ShieldCheck, Ship, Package, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/site/shared";

const SERVICES = [
  { key: "sourcing", Icon: Network },
  { key: "qc", Icon: ShieldCheck },
  { key: "logistics", Icon: Ship },
  { key: "packaging", Icon: Package },
];

export default function Services() {
  const { t } = useTranslation();
  return (
    <div data-testid="services-page">
      <PageHero kicker={t("services.kicker")} title={t("services.title")} subtitle={t("services.subtitle")} testId="services-hero" />

      <section className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-px bg-border border">
            {SERVICES.map(({ key, Icon }, i) => (
              <div key={key} className="bg-background p-8 lg:p-12" data-testid={`service-card-${key}`}>
                <div className="flex items-center justify-between">
                  <Icon className="h-9 w-9 text-primary" />
                  <span className="font-heading text-5xl font-black text-muted/80">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <h2 className="mt-6 font-heading text-2xl font-extrabold tracking-tight">{t(`services.${key}.title`)}</h2>
                <p className="mt-3 text-muted-foreground leading-relaxed">{t(`services.${key}.desc`)}</p>
              </div>
            ))}
          </div>

          <div className="mt-14 text-center">
            <Button asChild size="lg" className="rounded-none font-semibold h-12 px-8" data-testid="services-cta-quote">
              <Link to="/contact">
                {t("cta.quote")}
                <ArrowRight className="ms-2 h-4 w-4 rtl:rotate-180" />
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
